(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation.js');

'use strict';

const {
  ReactIconButton: IconButton,
  ReactIcon: Icon
} = svs.ui;
const {
  CarouselNavigationItem
} = svs.components.lbUi.carousel;
const {
  clx
} = svs.components.lbUtils;
const CarouselNavigation = _ref => {
  let {
    disabled,
    numberOfPages,
    onChange,
    selectedIndex,
    size
  } = _ref;
  const pageIndexes = [...Array(numberOfPages).keys()];
  const previous = () => {
    if (selectedIndex > 0) {
      onChange(selectedIndex - 1);
    }
  };
  const next = () => {
    if (selectedIndex + 1 < numberOfPages) {
      onChange(selectedIndex + 1);
    }
  };
  return React.createElement("div", {
    className: clx('carousel-nav', {
      'carousel-nav-disabled': disabled
    }),
    "data-testid": "carousel-navigation"
  }, React.createElement(IconButton, {
    "data-testid": "carousel-navigation-previous",
    onClick: previous
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: size
  })), React.createElement("div", {
    className: "carousel-nav-dots",
    "data-testid": "carousel-navigation-dots"
  }, pageIndexes.map(pageIndex => React.createElement(CarouselNavigationItem, {
    index: pageIndex,
    isActive: pageIndex === selectedIndex || pageIndexes.length === 1,
    key: "page-".concat(pageIndex),
    onChange: onChange,
    size: size
  }))), React.createElement(IconButton, {
    "data-testid": "carousel-navigation-next",
    onClick: next
  }, React.createElement(Icon, {
    icon: "menu-right",
    size: size
  })));
};
CarouselNavigation.defaultProps = {
  numberOfPages: 1,
  selectedIndex: 0,
  size: '300'
};
setGlobal('svs.components.lbUi.carousel.CarouselNavigation', CarouselNavigation);

 })(window);